import axios from 'axios';

import { apiBaseUrl } from './api';

export const register = async ({ phone, firstname, lastname, email, password }) => {
  return axios.post(
    `${apiBaseUrl}/account/register/intent`,
    {
      phone,
      firstname,
      lastname,
      email,
      password,
    },
    { withCredentials: true }
  );
};

export const phoneVerificationRegister = async ({ intentId, code }) => {
  return axios.post(
    `${apiBaseUrl}/account/register/phone-verification`,
    { intentId, code },
    { withCredentials: true }
  );
};
export const phoneVerificationRegisterResendCode = async ({ intentId }) => {
  return axios.post(
    `${apiBaseUrl}/account/register/phone-verification/resend-code`,
    { intentId },
    { withCredentials: true }
  );
};

export const optChannelSelect = async ({ intent, password, otpChannel }) => {
  return axios.post(
    `${apiBaseUrl}/account/signin/verification`,
    { intent, password, otpChannel },
    { withCredentials: true }
  );
};

export const otpVerificationSignIn = async ({ intent, password, code, otpChannel }) => {
  return axios.post(
    `${apiBaseUrl}/account/signin/verification`,
    { intent, password, code, otpChannel },
    { withCredentials: true }
  );
};

export const phoneVerificationSignInResendCode = async ({ intent }) => {
  return axios.post(
    `${apiBaseUrl}/account/signin/phone-verification/resend-code`,
    { intent },
    { withCredentials: true }
  );
};

export const phoneVerificationReset = async ({ code, intentId }) => {
  return axios.post(
    `${apiBaseUrl}/account/recovery/password/phone-verification`,
    {
      code,
      intentId,
    },
    { withCredentials: true }
  );
};

export const phoneVerificationResetResendCode = async ({ intent }) => {
  return axios.post(
    `${apiBaseUrl}/account/recovery/password/resend-code`,
    { intent },
    { withCredentials: true }
  );
};

export const signIn = async (values) => {
  return axios.post(`${apiBaseUrl}/account/signin/token`, values, { withCredentials: true });
};

export const resetPassword = async ({ email }) => {
  return axios.post(
    `${apiBaseUrl}/account/recovery/password`,
    { email },
    { withCredentials: true }
  );
};

export const changePassword = async ({ password, intentId }) => {
  return axios.post(
    `${apiBaseUrl}/account/recovery/password/update`,
    { password, intentId },
    { withCredentials: true }
  );
};

export const getCredentialsFromInvitation = async (inviteToken) => {
  return axios.get(`${apiBaseUrl}/account/register/invite/${inviteToken}`, {
    withCredentials: true,
  });
};

export const acceptInvitation = async ({ firstname, lastname, password, inviteToken }) => {
  return axios.post(
    `${apiBaseUrl}/account/register/invite/${inviteToken}`,
    { firstname, lastname, password },
    {
      withCredentials: true,
    }
  );
};
